import type { AxiosInstance } from '@b2ag/axios-client'
import { createFrontAxiosClient } from '@b2ag/axios-client'
import { mapListFromApi } from './discount.mapper'

export type IDiscountService = {
  findDiscounts(offerIdList: string[], cooperativeId: number): Promise<any[]>
}

export class DiscountService {
  api: AxiosInstance

  constructor({ discountApiHost }: { discountApiHost: string }) {
    this.api = createFrontAxiosClient(discountApiHost)
  }

  async findDiscounts(offerIdList: string[], cooperativeId: number) {
    if (!offerIdList.length) {
      return []
    }
    const response = await this.api.post(
      `/v2/discounts-for-sale/query`,
      { discountable_ids: offerIdList },
      { params: { seller_id: cooperativeId } },
    )
    return mapListFromApi(response.data, cooperativeId)
  }
}
